import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@dealer-center/core-components";

export function UserAccordionItem({ userEntity }: { userEntity: string }) {
  return (
    <Accordion>
      <AccordionSummary>User</AccordionSummary>
      <AccordionDetails>
        <pre>{userEntity}</pre>
      </AccordionDetails>
    </Accordion>
  );
}
